import React, { Component } from 'react';
import { 
    Table, 
    Button, 
    ModalHeader, 
    ModalBody, 
    ModalFooter, 
    Dropdown, 
    DropdownToggle, 
    DropdownItem, 
    DropdownMenu, 
    Col, 
    Row, 
    CardBody, 
    Card, 
    Label,
    Input
} from 'reactstrap'
import { connect } from 'react-redux';
import { Preloading } from '../../components/UI/Preloader/action';
import fileSaver from 'file-saver';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import {
    downloadEWSReportRequest,
} from "../../Corporate/my-portfolio/monitoring/action";
import { toast } from 'react-toastify';
import {
    getPublishDataRequest,
    getPublishListRequest,
    downloadEWSReportByDateRequest,
    sendEWSIndividualMailRequest,
    ewsCorporateNamesDownloadRequest,
    ewsCorporateNamesUploadRequest,
} from './action';
import Modal from '../../components/UI/Modal/Modal';
import {
    displayErrorMessage, displaySuccessMessage,
} from '../../Corporate/my-portfolio/monitoring/charts/monitoring-util';

const CLOSE = "CLOSE";
const PROCEED = "PROCEED";

class EWSReport extends Component {
    state = {
        isPortfolio: true,
        selectedPublish: null,
        publishList: [],
        publishData: [],
        confirmModal: false,
        downloadReportDrowpdown: false,
        downloadReportDrowpdownId: -1,
        corporateName: '',
        fromDate: null,
        toDate: null,
        downloadReportDropdownDisable: true,
        selectedPublishForEdit: null,
        corporateNamesUploadModal: false,
        corporateNamesUploadFile: null,
    };

    componentDidMount() {
        this.props.getPublishListRequest();
    }

    componentDidUpdate(prevProps) {
        if (this.props.ewsReportResponse !== prevProps.ewsReportResponse) {
            this.props.preloading(false);
            if (this.props.ewsReportResponse.status === "SUCCESS") {
                let statusCode = this.props.ewsReportResponse.data['status'];
                if (statusCode === 200) {
                    const data = this.props.ewsReportResponse.data.data;
                    let blob = new Blob([data], { type: 'application/octet-stream' });
                    let fileName = `${(this.state.corporateName != '' ? this.state.corporateName : 'Consolidated') 
                        + '_' + this.state.selectedPublish.label 
                        + (this.state.isPortfolio ? '_Portfolio' : '_Non_Portfolio') +'_'
                        + moment().format("DD_MMM_YYYY")}.xlsx`;
                    fileSaver.saveAs(blob, fileName);
                } else if (statusCode === 202) {
                    displaySuccessMessage("EWS Consolidated Report Request Has Been Placed Successfully! ");
                } else if (statusCode === 204) {
                    toast.error(
                        <div>
                            <i className="fa fa-exclamation-triangle"></i> No data Available!!
                        </div>
                    );
                }
            } else if (this.props.ewsReportResponse.status === "FAILURE") {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i> Please Try again!!
                    </div>
                );
            }
        }

        if (this.props.ewsReportResponseByDate !== prevProps.ewsReportResponseByDate) {
            this.props.preloading(false);
            if (this.props.ewsReportResponseByDate.status === "SUCCESS") {
                let statusCode = this.props.ewsReportResponseByDate.data['status'];
                if (statusCode === 202) {
                    displaySuccessMessage("EWS Consolidated Report Request Has Been Placed Successfully! ");
                } else if (statusCode === 204) {
                    toast.error(
                        <div>
                            <i className="fa fa-exclamation-triangle"></i> No data Available!!
                        </div>
                    );
                }
            } else if (this.props.ewsReportResponseByDate.status === "FAILURE") {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i> Please Try again!!
                    </div>
                );
            }
        }

        if (this.props.publishList != prevProps.publishList) {
            let publishes = [];
            
            if(this.props.publishList.data != ''){
                this.props.publishList.data.forEach(item => {
                    publishes.push({ value: item.id, label: <div>{item.publishName} <i className="fa fa-circle" style={{ color: item.active ? 'green' : 'red', float: 'right' }}></i></div> });
                });
            }

            this.setState({
                publishList: publishes,
            })
        }

        if (this.props.publishData != prevProps.publishData) {
            this.props.preloading(false);
            this.setState({
                publishData: this.props.publishData.data,
            })
        }

        if (this.props.ewsCorporateNamesDownloadResponse != prevProps.ewsCorporateNamesDownloadResponse) {
            this.props.preloading(false);
            if (this.props.ewsCorporateNamesDownloadResponse.status === "SUCCESS") {
                let filename = "EWS Corporate List For Publish-" + this.state.selectedPublishForEdit.label + ".xlsx";

                const headers = this.props.ewsCorporateNamesDownloadResponse.data.headers;
                const contentDisposition = headers != null ? headers['content-disposition'] : null;
                if (contentDisposition && contentDisposition.includes('filename=')) {
                    filename = contentDisposition.split('filename=')[1].replace(/"/g, '');
                }
                const data = this.props.ewsCorporateNamesDownloadResponse.data.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, filename);
            } else if (this.props.ewsCorporateNamesDownloadResponse.status === "FAILURE") {
                displayErrorMessage("Please Try again !!");
            }
        }

        if (this.props.ewsCorporateNamesUploadResponse != prevProps.ewsCorporateNamesUploadResponse) {
            this.props.preloading(false);
            if (this.props.ewsCorporateNamesUploadResponse.status === "SUCCESS") {
                displaySuccessMessage(`Corporate Names For Publish- ${this.state.selectedPublishForEdit.label} Updated Successfully !!`)
            } else if (this.props.ewsCorporateNamesUploadResponse.status === "FAILURE") {
                displayErrorMessage("Error Occured Updating Corporate Names For Selected Publish !!");
            }
        }        
    }

    handlePublishChange = (data) => {
        this.props.preloading(true);
        this.setState({
            selectedPublish: { value: data.value, label: data.label.props.children[0] },
            downloadReportDropdownDisable: false,
            fromDate: null,
            toDate: null,
        });
        this.props.getPublishDataRequest({ publishId: data.value });
    }

    downloadEWSReport = (isPortfolio, corporateId, corporateName) => {
        this.props.preloading(true);
        if(this.state.fromDate && this.state.toDate){
            this.props.downloadEWSReportByDateRequest({
                fromDate: moment(this.state.fromDate).format("DD-MM-YYYY"),
                toDate: moment(this.state.toDate).format("DD-MM-YYYY"),
                isPortfolio: isPortfolio,
            });
        }else{
            var selectedPublishMetadata = this.props.publishList.data.find(obj => {
                return obj.id ===  this.state.selectedPublish.value
            });
            this.props.downloadEWSReportRequest({
                corporateId: corporateId,
                publishId: this.state.selectedPublish.value,
                publishName: selectedPublishMetadata.publishName,
                fromDate: selectedPublishMetadata.fromDate,
                isPortfolio: isPortfolio,
            });
        }

        this.setState({
            isPortfolio: isPortfolio,
            corporateName: corporateName,
        })
    }

    handleSendEWSReportMail = (e, corporateId, publishId) => {
        this.props.preloading(true);
        console.log("publishId: ", publishId);
        this.props.sendEWSIndividualMailRequest({
            publishId: publishId.value,
            corporateId: corporateId,
        });

        // this.setState({ 
        //     selectedCorporate: corporateId,
        //     selectedPublish: this.state.selectedPublish.value
        //  })
    }

    handleConfirmModalButton = (type) => {
        if (type === PROCEED) {
            // to be implemented
            this.setState({ confirmModal: !this.state.confirmModal });
        } else if (type === CLOSE) {
            this.setState({ confirmModal: !this.state.confirmModal });
        }
    }

    downloadReportToggle = (dropdownId) => {
        this.setState((prevState) => ({
            downloadReportDrowpdownId: dropdownId,
            downloadReportDrowpdown: !prevState.downloadReportDrowpdown,
        }));
    }

    handleFromDateChange = (date) => {
        this.setState({
            fromDate: date,
            selectedPublish: null,
            downloadReportDropdownDisable: this.state.toDate ? false : true,
        });
    }

    handleToDateChange = (date) => {
        this.setState({
            toDate: date,
            selectedPublish: null,
            downloadReportDropdownDisable: this.state.fromDate ? false : true,
        });
    }

    handlePublishForEditChange = (data) => {
        this.setState({
            selectedPublishForEdit: { value: data.value, label: data.label.props.children[0] },
        });
    }

    downloadPublishCorporates = () => {
        this.props.ewsCorporateNamesDownloadRequest({
            publishId: this.state.selectedPublishForEdit.value
        });
        this.props.preloading(true);
    }

    uploadFileForCorporateNames = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && file.name.endsWith(".xlsx")) {
            this.setState({
                corporateNamesUploadFile: file,
            });
        } else {
            this.setState({
                corporateNamesUploadFile: undefined,
            });
            e.target.value = null;
            displayErrorMessage("Please upload Excel File only !");
        }
    }

    toogleCorporateNamesUploadModal = () => {
        this.setState({
            corporateNamesUploadModal: true,
        });
    }

    uploadCorporateNamesFile = () => {
        this.setState({
            corporateNamesUploadModal: false
        });
        this.props.ewsCorporateNamesUploadRequest({
            file: this.state.corporateNamesUploadFile,
            publishId: this.state.selectedPublishForEdit.value
        });
        this.props.preloading(true);
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">EWS Publish Update Corporates</h4>
                </div>
                <Card>
                    <CardBody style={{ paddingBottom: "30px" }}>
                        <Row>
                            <Col sm={7}>
                                <Select
                                    placeholder={'Select Publish Name'}
                                    defaultValue={this.state.selectedPublishForEdit}
                                    value={this.state.selectedPublishForEdit}
                                    onChange={this.handlePublishForEditChange}
                                    options={this.state.publishList} />
                            </Col>
                            <Col>
                                <Button
                                    color="primary"
                                    disabled={!this.state.selectedPublishForEdit}
                                    onClick={this.downloadPublishCorporates}>
                                    Download Corporates List
                                </Button>
                            </Col>
                            <Col>
                                <Input
                                    title='Upload Corporate List File'
                                    id="upload-corporate-names-file"
                                    type="file"
                                    disabled={!this.state.selectedPublishForEdit}
                                    onChange={(e) => this.uploadFileForCorporateNames(e)}
                                    className="btn position-relative"
                                    style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col>
                                <Button
                                    color="primary"
                                    disabled={!this.state.selectedPublishForEdit}
                                    onClick={this.toogleCorporateNamesUploadModal}>
                                    Upload Corporates List
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">EWS Report Download/Email</h4>
                </div>
                <Card>
                    <CardBody style={{ paddingBottom: "30px" }}>
                        <Label>EWS Report Download</Label>
                        <Row>
                            <Col sm={7}>
                                <Select
                                    placeholder={'Select Publish Name'}
                                    defaultValue={this.state.selectedPublish}
                                    value={this.state.selectedPublish}
                                    onChange={this.handlePublishChange}
                                    options={this.state.publishList} />
                            </Col>
                            <Label>OR</Label>
                            <Col sm={5}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.fromDate}
                                    onChange={this.handleFromDateChange}
                                    placeholderText="Enter from date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col sm={5}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.toDate}
                                    onChange={this.handleToDateChange}
                                    placeholderText="Enter to date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col>
                                <Dropdown
                                    isOpen={this.state.downloadReportDrowpdown && this.state.downloadReportDrowpdownId == 0} 
                                    toggle={() => this.downloadReportToggle(0)}>
                                    <DropdownToggle 
                                        disabled={this.state.downloadReportDropdownDisable} 
                                        color="primary" 
                                        style={{ width: '260px' }}>
                                        Download Consolidated Report  <i className="fa fa-caret-down"></i>
                                    </DropdownToggle>
                                    <DropdownMenu style={{ width: '260px' }}>
                                        <DropdownItem 
                                            name='portfolio' 
                                            onClick={() => this.downloadEWSReport(true, '', '')}>
                                            Portfolio
                                        </DropdownItem>
                                        <DropdownItem 
                                            name='non-portfolio' 
                                            onClick={() => this.downloadEWSReport(false, '', '')}>
                                            Non-Portfolio
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </Col>
                        </Row>
                    </CardBody>

                    <Table hidden={!this.state.selectedPublish}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Corporate Id</th>
                                <th>Corporate Name</th>
                                <th>EWS Report</th>
                                <th>Send Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.publishData && this.state.publishData.length > 0 &&
                                this.state.publishData.map((obj, index) => <tr key={index}>
                                    <th scope="row">{index + 1}</th>
                                    <td>{obj.corporateId}</td>
                                    <td>{obj.corporateName}</td>
                                    <td>
                                        <Dropdown 
                                        color="primary" 
                                        isOpen={this.state.downloadReportDrowpdown && this.state.downloadReportDrowpdownId == (index + 1)} 
                                        toggle={() => this.downloadReportToggle(index + 1)}>
                                            <DropdownToggle color="primary" style={{ width: '140px' }}>
                                                Download  <i className="fa fa-caret-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem 
                                                    name='portfolio'
                                                    onClick={() => this.downloadEWSReport(true, obj.corporateId, obj.corporateName)}>
                                                    Portfolio
                                                </DropdownItem>
                                                <DropdownItem 
                                                    name='non-portfolio' 
                                                    onClick={() => this.downloadEWSReport(false, obj.corporateId, obj.corporateName)}>
                                                    Non-Portfolio
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </Dropdown>
                                    </td>
                                    <td>
                                        <Button 
                                            color='primary' 
                                            onClick={(e) => this.handleSendEWSReportMail(e, obj.corporateId, this.state.selectedPublish)}>
                                            <i className="fa fa-envelope-o"></i>
                                        </Button>
                                    </td>
                                </tr>)}
                        </tbody>
                    </Table>
                </Card>

                {/* Corporate Names Upload File Modal */}
                <Modal show={this.state.corporateNamesUploadModal} className='Modal shadow-none cp-upload-modal' >
                    <ModalHeader className="label-text-center">Upload Corporate Names</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Label className="label-text-center">
                            { this.state.selectedPublishForEdit && this.state.corporateNamesUploadFile ?
                                `Do You Wish To Proceed With Uploading Corporate List For The Report : ${this.state.selectedPublishForEdit.label}?`
                                : null
                            }
                            </Label>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ corporateNamesUploadModal: false })}>Close</Button>
                        <Button color="primary" onClick={this.uploadCorporateNamesFile}>Confirm</Button>
                    </ModalFooter>
                </Modal>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    ewsReportResponse: state.monitoringData.corporateEWSReport,
    publishList: state.ews.publishListResponse,
    publishData: state.ews.publishData,
    ewsReportResponseByDate: state.ews.downloadReportResponse,
    ewsCorporateNamesDownloadResponse: state.ews.ewsCorporateNamesDownloadResponse,
    ewsCorporateNamesUploadResponse: state.ews.ewsCorporateNamesUploadResponse,
})

const mapDispatchToProps = (dispatch) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    downloadEWSReportRequest: (data) => { dispatch(downloadEWSReportRequest(data)) },
    getPublishListRequest: data => { dispatch(getPublishListRequest(data)) },
    getPublishDataRequest: data => { dispatch(getPublishDataRequest(data)) },
    downloadEWSReportByDateRequest: data => { dispatch(downloadEWSReportByDateRequest(data)) },
    sendEWSIndividualMailRequest: data => {dispatch(sendEWSIndividualMailRequest(data)) },
    ewsCorporateNamesDownloadRequest: (data) => {dispatch(ewsCorporateNamesDownloadRequest(data))},
    ewsCorporateNamesUploadRequest: (data) => {dispatch(ewsCorporateNamesUploadRequest(data))},
});

export default connect(mapStateToProps, mapDispatchToProps)(EWSReport);